import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import axios from 'axios';
import {
  Navbar,
  NavbarBrand,
  Container,
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap"
import FormData from 'form-data'

import RichText from '../components/rich-text'

import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/index.scss'

export default ({ data }) => {
  const [isClient, setIsClient] = useState(false)
  useEffect(() => {
    setIsClient(true)
  });

  const [submittedText, setSubmittedText] = useState({text: "", className: ""});
  const [validateClasses, setValidateClasses] = useState({
    name: false,
    org: false,
    phone: false,
    email: false,
    project: false,
    location: false,
  })

  const validate = (formData) => {
    if (
        !formData.get("name") ||
        !formData.get("organization") ||
        !formData.get("phone-number") ||
        !formData.get("email") ||
        !formData.get("project-name") ||
        !formData.get("location")
       ) {
      setValidateClasses({
        name: formData.get("name") ? false : true,
        org: formData.get("organization") ? false : true,
        phone: formData.get("phone-number") ? false : true,
        email: formData.get("email") ? false : true,
        project: formData.get("project-name") ? false : true,
        location: formData.get("location") ? false : true,
      })
      setSubmittedText({text: "Please fill in the highlighted fields", className: "red"})
      return false
    }

    if (
        !formData.get("ownership") ||
        !formData.get("rights")
    ) {
      setSubmittedText({text: "Please confirm ownership and grant rights to CfAD", className: "red"})
      return false
    }

    if (
        !formData.get("file1") &&
        !formData.get("file2") &&
        !formData.get("file3") &&
        !formData.get("file4") &&
        !formData.get("file5")
    ) {
      setSubmittedText({text: "Please submit at least one file", className: "red"})
      return false
    }

    return true
  }

  const onSubmit = e => {
    e.preventDefault()
    const formData = new FormData(document.getElementById("mainForm"))

    setValidateClasses({
      name: false,
      org: false,
      phone: false,
      email: false,
      project: false,
      location: false,
    })

    setSubmittedText({text: "", className: ""})

    if (validate(formData)) {
      axios({
        method: 'POST',
        url: process.env.UPLOAD_URL || 'https://api.fitwel.org/photoupload',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'}
      })
        .then((res) => {
          document.getElementById("mainForm").reset()
          setSubmittedText({text: "Submitted!", className: ""});
        })
        .catch((err) => {
          console.log(err)
          setSubmittedText({text: "Something went wrong, please try again", className: "red"});
        })
    }
  }

  const clearBorder = field => {
    let newValidateClasses = {...validateClasses}
    newValidateClasses[field] = ""
    setValidateClasses(newValidateClasses)
  }

  const pageData = data.contentfulUploadPage

  return (
    <div key={isClient}>
      <Navbar color="light">
        <Container>
          <NavbarBrand href="/">
              { pageData.pageTitle }
          </NavbarBrand>
        </Container>
      </Navbar>
      <Container>
        <Row>
          <Col md="9">
            <RichText content={ pageData.headerParagraph }/>
            <Form onSubmit={ onSubmit } id="mainForm">
              <h3>Submitter Info</h3>
              <hr/>
              <FormGroup>
                <Input invalid={validateClasses.name} onChange={() => clearBorder("name")} type="text" name="name" id="name" placeholder="Your Name*"/>
              </FormGroup>
              <FormGroup>
                <Input invalid={validateClasses.org} onChange={() => clearBorder("org")} type="text" name="organization" id="org" placeholder="Organization*"/>
              </FormGroup>
              <FormGroup>
                <Input invalid={validateClasses.phone} onChange={() => clearBorder("phone")} type="text" name="phone-number" id="phone" placeholder="Phone Number*"/>
              </FormGroup>
              <FormGroup>
                <Input invalid={validateClasses.email} onChange={() => clearBorder("email")} type="email" name="email" id="email" placeholder="Email*"/>
              </FormGroup>
              <h3>Confirmations</h3>
              <hr/>

              <p>
                <RichText content={ pageData.legalText1 }/>
              </p>

              <FormGroup>
                <Label check>
                  <Input type="checkbox" name="ownership" id="ownership"/>{' '}
                  { pageData.checkbox1 }
                </Label>
              </FormGroup>

              <p>
                <RichText content={ pageData.legalText2 }/>
              </p>

              <FormGroup>
                <Label check >
                  <Input type="checkbox" name="rights" id="rights"/>{' '}
                  { pageData.checkbox2 }
                </Label>
              </FormGroup>

              <h3>File Uploads and Attribution</h3>
              <hr/>
              <FormGroup>
                <Input invalid={validateClasses.project} onChange={() => clearBorder("project")} type="text" name="project-name" id="project" placeholder="Project/Initiative Name*"/>
              </FormGroup>
              <FormGroup>
                <Input invalid={validateClasses.location} onChange={() => clearBorder("location")} type="text" name="location" id="location" placeholder="Location (Ex. New York, NY)*"/>
              </FormGroup>
              <FormGroup>
                <Input type="textarea" name="comments" id="comments" placeholder="Additional comments"/>
              </FormGroup>
              <p>Please upload JPG or TIF images at print resolution (3500 x 2000 pixels approximately), 20MB maximum per file</p>
              <Row>
                <Col xs="1">
                  <h5>File #1</h5>
                </Col>
                <Col xs="11">
                  <FormGroup>
                    <Input type="text" name="credit1" id="credit1" placeholder="Photo Credit (Ex. Photo Courtesy of Center for Active Design [or] (c) Center for Active Design)"/>
                  </FormGroup>
                  <FormGroup>
                    <Input type="file" name="file1" id="file1"/>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="1">
                  <h5>File #2</h5>
                </Col>
                <Col xs="11">
                  <FormGroup>
                    <Input type="text" name="credit2" id="credit2" placeholder="Photo Credit (Ex. Photo Courtesy of Center for Active Design [or] (c) Center for Active Design)"/>
                  </FormGroup>
                  <FormGroup>
                    <Input type="file" name="file2" id="file2"/>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="1">
                  <h5>File #3</h5>
                </Col>
                <Col xs="11">
                  <FormGroup>
                    <Input type="text" name="credit3" id="credit3" placeholder="Photo Credit (Ex. Photo Courtesy of Center for Active Design [or] (c) Center for Active Design)"/>
                  </FormGroup>
                  <FormGroup>
                    <Input type="file" name="file3" id="file3"/>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="1">
                  <h5>File #4</h5>
                </Col>
                <Col xs="11">
                  <FormGroup>
                    <Input type="text" name="credit4" id="credit4" placeholder="Photo Credit (Ex. Photo Courtesy of Center for Active Design [or] (c) Center for Active Design)"/>
                  </FormGroup>
                  <FormGroup>
                    <Input type="file" name="file4" id="file4"/>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="1">
                  <h5>File #5</h5>
                </Col>
                <Col xs="11">
                  <FormGroup>
                    <Input type="text" name="credit5" id="credit5" placeholder="Photo Credit (Ex. Photo Courtesy of Center for Active Design [or] (c) Center for Active Design)"/>
                  </FormGroup>
                  <FormGroup>
                    <Input type="file" name="file5" id="file5"/>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={2}>
                  <FormGroup role="form">
                    <Button type="submit">Submit</Button>
                  </FormGroup>
                </Col>
                <Col className={`submittedText ${submittedText.className}`}>
                  { submittedText.text }
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export const query = graphql`
query uploadPageQuery {
  contentfulUploadPage {
    pageTitle
    headerParagraph {
      json
    }
    checkbox1
    legalText1 {
      json
    }
    checkbox2
    legalText2 {
      json
    }
  }
}
`
